import { render, staticRenderFns } from "./order-modal-resi.vue?vue&type=template&id=835c080e&scoped=true"
import script from "./order-modal-resi.vue?vue&type=script&lang=js"
export * from "./order-modal-resi.vue?vue&type=script&lang=js"
import style0 from "./order-modal-resi.vue?vue&type=style&index=0&id=835c080e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835c080e",
  null
  
)

export default component.exports